import { Form, Tooltip } from "antd";
import React from "react";
import Input from "./BaseInput";
import FrequentlyUsedFieldNameMap from "@/map/FrequentlyUsedFieldNameMap";
import FrequentlyUsedField from "@/enum/FrequentlyUsedField";

const PrintBatchNoField: React.FC = () => {
    return (
        <Tooltip
            title={
                <div>
                    <p>1、批次号最多可同时搜索20个</p>
                    <p>2、多个批次号间可用逗号、换行、空格分隔</p>
                </div>
            }
        >
            <Form.Item
                label={
                    <span className="search-field-label">
                        {FrequentlyUsedFieldNameMap[FrequentlyUsedField.PRINT_BATCH_NO]}
                    </span>
                }
                name="printBatchNo"
            >
                <Input allowClear />
            </Form.Item>
        </Tooltip>
    );
};

export default React.memo(PrintBatchNoField);
